import Cookie from "js-cookie";
// import { services } from "./constants";


export function getCookieValue(key) {
  return Cookie.get(key);
}

export function clearCookieValue(key) {
  return Cookie.remove(key);
}

export function saveCookie(key, value) {
  Cookie.set(key, value, { expires: 7 });
}

export const validateEmail = (email) => {
  var re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  return re.test(email);
};

// export function calculateWorkDays(userServices, farmSize) {
//   let available = []
//   if(Array.isArray(userServices)) {
//     services.forEach((val) => {
//       userServices.map(serv => serv === val.value ? available.push(val) : null)
//     })
//   }
  
// }